import { render, staticRenderFns } from "./SystemExplanation.vue?vue&type=template&id=25bb07df&scoped=true"
import script from "./SystemExplanation.vue?vue&type=script&lang=js"
export * from "./SystemExplanation.vue?vue&type=script&lang=js"
import style0 from "./SystemExplanation.vue?vue&type=style&index=0&id=25bb07df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bb07df",
  null
  
)

export default component.exports